import React, { useContext, useState } from "react";
import {
  Dialog,
  Grid,
  Typography,
  TextField,
  Button,
  Autocomplete,
  Box,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import parse from "autosuggest-highlight/parse";
import { debounce } from "@mui/material/utils";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { AppContext } from "../context/app.context";
import ServiceImage1 from "../../Assets/Gif/LocationGif.gif";

// This key was created specifically for the demo in mui.com.
// You need to create a new one for your application.
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_KEY;
// const GOOGLE_MAPS_API_KEY = "AIzaSyC3aviU6KHXAjoSnxcw6qbOhjnFctbxPkE";

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement("script");
  script.setAttribute("async", "");
  script.setAttribute("id", id);
  script.src = src;
  position.appendChild(script);
}

const autocompleteService = { current: null };
const LocationAccessPop = ({ locationDeniedPop, setLocationDeniedPop }) => {
  const theme = useTheme();
  const { getUserData, branchList } = useContext(AppContext);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [value, setValue] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = useState("");
  const loaded = React.useRef(false);

  if (typeof window !== "undefined" && !loaded.current) {
    if (!document.querySelector("#google-maps")) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`,
        document.querySelector("head"),
        "google-maps"
      );
    }

    loaded.current = true;
  }

  const fetch = React.useMemo(
    () =>
      debounce((request, callback) => {
        autocompleteService.current.getPlacePredictions(request, callback);
      }, 400),
    []
  );
  console.log("Location Pop");

  React.useEffect(() => {
    let active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current =
        new window.google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);

  const findBranch = async () => {
    try {
      const response = await global.$axios.post("location/getCoordinates", {
        address: value ? value?.structured_formatting?.main_text : "",
        id: global.$userData.id,
      });
      if (response.data.status == "success") {
        setLocationDeniedPop(false);
        getUserData();
        branchList(response.data.longitude, response.data.latitude);
        console.log("res", response.data);
      } else {
        setLocationDeniedPop(true);
      }
    } catch (error) {
      console.log("find Branch Error", error);
    }
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={locationDeniedPop}
      fullWidth={true}
      maxWidth={"md"}
      sx={{ ".MuiDialog-container": { alignItems: "flex-start" } }}
      // onClose={() => value && setLocationDeniedPop(false)}
    >
      <Grid
        sx={{
          py: { md: 10, xs: 3 },
          px: { md: 2, xs: 0 },
          display: "flex",

          alignItems: "center",
          flexDirection: "column",
        }}
        style={{ maxHeight: "50%" }}
      >
        <Typography sx={{ color: "#071CB7", fontWeight: 600 }}>
          Now Book Service from your nearest branch
        </Typography>
        <Typography sx={{ color: "#23232399", mt: 3 }}>
          Enter your location to wonder your car
        </Typography>
        <Grid
          sx={{
            my: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            sx={{
              height: { xs: "50%", sm: "20%" },
              width: { xs: "50%", sm: "20%" },
              maxHeight: { xs: "90%" },
              maxWidth: { xs: "100%" },
              borderRadius: 2,
            }}
            alt="5k Car Care"
            src={ServiceImage1}
          />
        </Grid>
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            width: { md: "80%", xs: "90%" },
            justifyContent: "center",
          }}
        >
          <Autocomplete
            id="google-map-demo"
            sx={{
              ".css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root": {
                borderRadius: 0,
              },
              width: { md: "50%", xs: "70%" },
            }}
            size="small"
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.description
            }
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            noOptionsText="No locations"
            onChange={(event, newValue) => {
              setOptions(newValue ? [newValue, ...options] : options);
              setValue(newValue);
            }}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Add a location" fullWidth />
            )}
            renderOption={(props, option) => {
              const matches =
                option.structured_formatting.main_text_matched_substrings || [];

              const parts = parse(
                option.structured_formatting.main_text,
                matches.map((match) => [
                  match.offset,
                  match.offset + match.length,
                ])
              );

              return (
                <li {...props}>
                  <Grid container alignItems="center">
                    <Grid item sx={{ display: "flex", width: 44 }}>
                      <LocationOnIcon sx={{ color: "text.secondary" }} />
                    </Grid>
                    <Grid
                      item
                      sx={{
                        width: "calc(100% - 44px)",
                        wordWrap: "break-word",
                      }}
                    >
                      {parts.map((part, index) => (
                        <Box
                          key={index}
                          component="span"
                          sx={{
                            fontWeight: part.highlight ? "bold" : "regular",
                          }}
                        >
                          {part.text}
                        </Box>
                      ))}
                      <Typography variant="body2" color="text.secondary">
                        {option.structured_formatting.secondary_text}
                      </Typography>
                    </Grid>
                  </Grid>
                </li>
              );
            }}
          />

          <Button
            sx={{
              background: "#071CB7",
              borderRadius: 0,
              p: 0.95,
              textTransform: "capitalize",
            }}
            variant="contained"
            onClick={() => findBranch()}
          >
            Find Branch
          </Button>
        </Grid>
        {/* {searchValue?.length > 0 && (
          <Grid
            sx={{
              width: { md: "80%", xs: "80%" },
              maxWidth: { md: "40%", xs: "80%" },
              mt: 0.5,
              maxHeight: 160,
              overflow: "auto",
              position: { xs: "absolute" },
              bottom: { md: 40, xs: 320 },

              background: "#FFF",
            }}
          >
            {Array.from(new Array(15)).map((index) => {
              return (
                <Typography sx={{ my: 1 }}>Sathyam Cinemas, Chennai</Typography>
              );
            })}
          </Grid>
        )} */}
        <Typography
          sx={{
            color: "#BF0A30 ",
            p: 2,
            textAlign: "center",
            mt: 3,
            mx: 5,
            border: "1px solid #CD5C5C",
          }}
        >
          To get your current location automatically,change your location
          settings in browser.
          <Typography sx={{ color: "#BF0A30 ", p: 2 }}>
            உங்கள் தற்போதைய இருப்பிடத்தை தானாகவே பெற, உலாவியில் உங்கள் இருப்பிட
            அமைப்புகளை மாற்றவும்.
          </Typography>
        </Typography>
      </Grid>
    </Dialog>
  );
};

export default LocationAccessPop;
